<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7GNpK2/tc-custom/9781423656753.jpg?1737126689483" alt="This image is the cover for the book Forager's Pantry"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Forager's Pantry
      </h1>
      <p class="bookDescription body article font2">
        <p>f you’d like to experiment with wild foods and explore new flavors, but don’t know where to start—The Forager’s Pantry was written for you. This comprehensive and accessible book by Ellen Zachos takes readers through spices and herbs, flowers, fruit, greens, nuts and seeds, tubers and roots, and mushrooms, showing how some of the best ingredients come from nature itself.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ellen Zachos
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gibbs Smith
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6603417b